import React, { useState } from 'react';
import {
  useStripe,
  useElements,
  PaymentElement,
} from '@stripe/react-stripe-js';
import { Button, Box, Typography, CircularProgress } from '@mui/material';

const PaymentForm = ({ onPaymentSuccess, onCancel, totalPrice }) => {
  const stripe = useStripe();
  const elements = useElements();
  const [error, setError] = useState(null);
  const [processing, setProcessing] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!stripe || !elements) {
      setError('Stripe is not loaded. Please try again later.');
      return;
    }
    setProcessing(true);

    try {
      const { error, paymentIntent } = await stripe.confirmPayment({
        elements,
        // clientSecret,
        confirmParams: {
          return_url: `${window.location.origin}/createpost`,
        },
        redirect: 'if_required',
      });

      if (error) {
        setError(error.message);
      } else if (paymentIntent.status === 'succeeded') {
        onPaymentSuccess();
      }
    } catch (err) {
      setError('Payment failed');
    } finally {
      setProcessing(false);
    }
  };

  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: '700px', // Increase from default
        margin: '0 auto',
        padding: '20px',
      }}
    >
      <Typography
        variant='h6'
        sx={{
          fontFamily: 'Montserrat',
          mb: 3,
          mt: 2,
          textAlign: 'center',
        }}
      >
        Complete Payment to Submit Your Post
      </Typography>

      {/* {clientSecret ? ( */}
      <form
        onSubmit={handleSubmit}
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          marginTop: '12px',
        }}
      >
        <Box
          sx={{
            mb: 1,
            width: '95%', // Update from 30%
            maxWidth: '500px', // Add max-width
            boxShadow: '0px 1px 4px grey',
            borderRadius: '12px',
            p: 2,
          }}
        >
          <Typography
            variant='h6'
            sx={{
              fontFamily: 'Montserrat',
              fontSize: '16px',
              mb: 1,
              fontWeight: '700',
            }}
          >
            Total Price: ${totalPrice}
          </Typography>

          {/* Render Payment Element */}
          <PaymentElement />
        </Box>

        {error && (
          <Typography color='error' sx={{ mt: 1 }}>
            {error}
          </Typography>
        )}
        <Box
          sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2, gap: 2 }}
        >
          <Button
            onClick={onCancel}
            variant='outlined'
            sx={{ borderRadius: '20px' }}
          >
            Cancel
          </Button>
          <Button
            type='submit'
            variant='contained'
            disabled={processing || !stripe}
            sx={{
              backgroundColor: 'darkblue',
              borderRadius: '20px',
              display: 'flex',
              alignItems: 'center',
              gap: 1,
            }}
          >
            {processing ? (
              <>
                <CircularProgress size={20} />
                <span>Processing Payment...</span>
              </>
            ) : (
              `Pay $${totalPrice}`
            )}
          </Button>
        </Box>
      </form>
    </Box>
  );
};

export default PaymentForm;
